<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { 
        fetchProveedores, 
        saveProveedor, 
        removeProveedor, 
        searchProveedores, 
        subscribeToProveedores, 
        unsubscribeFromProveedores 
    } from '../controllers/proveedorController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de proveedores
    let proveedorColumns = [
        { label: 'Código', field: 'codigo', type: 'text' },
        { label: $t('fields.name'), field: 'nombre', type: 'text' },
        { label: 'Sucursal', field: 'sucursal', type: 'relation', relationField: 'descrip' },
        { label: $t('fields.phone'), field: 'telefono', type: 'number' },
        { label: 'Email', field: 'email', type: 'email' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' }
    ];

    // Estructura del nuevo objeto Proveedor
    let newProveedor = {
        sucursal: null, // Relación con sucursal
        codigo: '',
        nombre: '',
        direccion: '',
        telefono: null,
        nit: null,
        email: '',
        dias_credito: null,
        limite_credito: null,
        sta: true,
    };

    // Configuración de los campos para la edición de proveedores
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Código', key: 'codigo', type: 'text', required: true },
        { label: $t('fields.name'), key: 'nombre', type: 'text', required: true },
        { label: $t('fields.address'), key: 'direccion', type: 'text', required: false },
        { label: $t('fields.phone'), key: 'telefono', type: 'number', required: true },
        { label: 'NIT', key: 'nit', type: 'number', required: true },
        { label: 'Email', key: 'email', type: 'email', required: true },
        { label: 'Días de Crédito', key: 'dias_credito', type: 'number', required: false },
        { label: 'Límite de Crédito', key: 'limite_credito', type: 'number', required: false },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true },
    ];

    // Opciones de sucursal
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title={$t('entities.proveedores')}
    entityName="proveedor"
    newEntity={newProveedor}
    columns={proveedorColumns}
    fetchEntities={fetchProveedores}
    saveEntity={saveProveedor}
    removeEntity={removeProveedor}
    searchEntities={searchProveedores}
    subscribeToChanges={subscribeToProveedores}
    unsubscribeFromChanges={unsubscribeFromProveedores}
    editColumns={editColumns}
/>
